import React, { useEffect } from 'react';
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
  useLocation,
  useNavigate,
} from 'react-router-dom';
import { useAuth } from './context/AuthContext';
import NavBar from './components/NavBar';
import MainPage from './pages/MainPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import SurveyResultPage from './pages/SurveyResultPage';
import PaymentPage from './pages/PaymentPage';
import DashboardPage from './pages/DashboardPage';
import SuccessPage from './pages/SuccessPage';
import SiteFooter from './components/SiteFooter';

function App() {
  const { token, isLoading } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  // Redirect to home if token is removed while on protected routes
  useEffect(() => {
    if (isLoading) return;
    const protectedPaths = ['/dashboard'];
    if (!token && protectedPaths.includes(location.pathname)) {
      navigate('/', { replace: true });
    }
  }, [token, isLoading, location.pathname, navigate]);

  // Scroll to top on route changes (exclude tab switches since they don't change pathname)
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  }, [location.pathname]);

  if (isLoading) {
    return <div>Loading...</div>; // Or a spinner component
  }

  return (
    <div className='App'>
      <NavBar />
      <Routes>
        <Route path='/' element={<MainPage />} />
        <Route path='/forgot-password' element={<ForgotPasswordPage />} />
        <Route path='/reset-password' element={<ResetPasswordPage />} />
        <Route
          path='/dashboard'
          element={token ? <DashboardPage /> : <Navigate to='/' />}
        />
        <Route
          path='/new-dashboard'
          element={<Navigate to='/dashboard' replace />}
        />
        <Route path='/survey-result' element={<SurveyResultPage />} />
        <Route path='/payment' element={<PaymentPage />} />
        <Route path='/success' element={<SuccessPage />} />

        {/* Legacy archived routes kept but redirected */}
        <Route path='/login' element={<Navigate to='/' replace />} />
        <Route path='/register' element={<Navigate to='/' replace />} />
        <Route path='/purchase' element={<Navigate to='/' replace />} />
        <Route path='/test-access' element={<Navigate to='/' replace />} />
        <Route path='/clinical-test' element={<Navigate to='/' replace />} />
      </Routes>
      <SiteFooter />
    </div>
  );
}

export default function RootApp() {
  return (
    <Router>
      <App />
    </Router>
  );
}
